export default (element) => {
  const { offsetLeft, scrollLeft, scrollWidth } = element;
  const { width } = element.getBoundingClientRect();

  return {
    offsetLeft,
    offsetRight: offsetLeft + width,
    scrollLeft,
    scrollRight: scrollLeft + width,
    scrollWidth,
    width,
  };
};
